import { Configuration, OpenAIApi } from "openai"
import { server } from "./api"
import { generate, getSettings, sendChatRequest } from "./api/api"
import { getAllPrompts, getPrompt } from "./api/PromptService"
import { PROMPT } from "./pages/Prompts"
import _ from "lodash"

export const getCompletion = async (prompt) => {
  const {
    data: { model },
  } = await getSettings()
  const { data } = await getAllPrompts()
  const excludedWords = _.find(data, { name: PROMPT.EXCLUDED_WORDS }).prompt
  const configuration = new Configuration({
    basePath: `${server}/v1`,
    organization: "org-SfyUsC5kfHAByNkg7W3z8yGL",
  })
  delete configuration.baseOptions.headers["User-Agent"]
  const openai = new OpenAIApi(configuration)
  try {
    const completion = await openai.createChatCompletion({
      model,
      messages: [
        {
          role: "user",
          content: `${prompt}\n\n${excludedWords}`,
        },
      ],
    })
    return completion.data.choices[0].message.content
  } catch (error) {
    console.log(error)
  }
}

export const generatePECSRRHashtags = async (prompt, title, targetAudience, n) => {
  const hashtagsPrompt = prompt
    .replace("${title}", title)
    .replace("${targetAudience}", targetAudience)
    .replace("${n - 1}", n - 1)
  return getCompletion(hashtagsPrompt)
}

export const generatePostSummary = async (prompt, post) => {
  const summaryPrompt = prompt.replace("${post}", post)
  return getCompletion(summaryPrompt)
}

export const getCompletionStreamed = async (message) => {
  const {
    data: { model },
  } = await getSettings()
  const { data } = await getAllPrompts()
  const excludedWords = _.find(data, { name: PROMPT.EXCLUDED_WORDS }).prompt
  const response = await sendChatRequest({
    model,
    messages: [
      {
        role: "user",
        content: `${message}\n\n${excludedWords}`,
      },
    ],
  })

  // ... (Rest of the code for reading and displaying responses)
  const reader = response.body.getReader()
  const textDecoder = new TextDecoder("utf-8")

  // Display the assistant's response in chunks
  let assistantResponse = ""
  while (true) {
    const { value, done } = await reader.read()
    if (done) break

    assistantResponse += textDecoder.decode(value, { stream: !done })
  }
  return assistantResponse
}

export const generateClientWritingStylePrompt = async (clientWriting) => {
  const {
    data: { prompt },
  } = await getPrompt(PROMPT.CLIENT_TONE)
  const tonePrompt = prompt.replace("${clientWriting}", clientWriting)
  return getCompletionStreamed(tonePrompt)
}

export const getToneOfVoiceOutput = (tonePrompt) =>getCompletionStreamed(tonePrompt, "gpt-4")


export const generatePECSRRCommentsNumbered = async (post, numberOfComments = 15) =>
  generate({
    prompt_type: "PECSRR_COMMENTS",
    opts: { post, numberOfComments },
  }).then(numberComments)

export const numberComments = (text) =>
  text
    .split("|")
    .map((c, index) => `${index + 1}. ${c.trim()}`)
    .join("\n\n")

export const generatePostWithTone = async ({
  clientToneOfVoice,
  problem,
  cost,
  solution,
  targetAudience,
}) => {
  const {
    data: { prompt },
  } = await getPrompt(PROMPT.PECSRR_POST_WITH_TONE)
  const interpolatedPrompt = prompt
    .replace("${clientToneOfVoice}", clientToneOfVoice)
    .replace("${problem}", problem)
    .replace("${cost}", cost)
    .replace("${solution}", solution)
    .replace("${targetAudience}", targetAudience)
  return getCompletionStreamed(interpolatedPrompt)
}

export const generateHeadlines = async (titlesPrompt, post) => {
  const prompt = titlesPrompt.replace("${pecsRR}", post)
  const configuration = new Configuration({
    basePath: `${server}/v1`,
    organization: "org-SfyUsC5kfHAByNkg7W3z8yGL",
  })
  delete configuration.baseOptions.headers["User-Agent"]
  const openai = new OpenAIApi(configuration)
  const { data } = await getAllPrompts()
  const excludedWords = _.find(data, { name: PROMPT.EXCLUDED_WORDS }).prompt
  try {
    const completion = await openai.createChatCompletion({
      temperature: 1,
      max_tokens: 1400,
      top_p: 1,
      frequency_penalty: 0,
      presence_penalty: 0,
      model: "gpt-3.5-turbo",
      messages: [
        {
          role: "user",
          content: `${prompt}\n\n${excludedWords}`,
        },
      ],
    })
    return completion.data.choices[0].message.content
  } catch (error) {
    console.log(error)
  }
}